import { createContext, useContext, useState, type ReactNode } from 'react';
import type { MediaType } from '../types/movie';

interface MediaTypeContextValue {
  mediaType: MediaType;
  setMediaType: (type: MediaType) => void;
  isTV: boolean;
}

const MediaTypeContext = createContext<MediaTypeContextValue | undefined>(undefined);

export function MediaTypeProvider({ children }: { children: ReactNode }) {
  const [mediaType, setMediaType] = useState<MediaType>('movie');

  return (
    <MediaTypeContext.Provider value={{
      mediaType,
      setMediaType,
      isTV: mediaType === 'tv',
    }}>
      {children}
    </MediaTypeContext.Provider>
  );
}

export function useMediaType() {
  const context = useContext(MediaTypeContext);
  if (!context) {
    throw new Error('useMediaType must be used within MediaTypeProvider');
  }
  return context;
}
